module.exports = __webpack_public_path__ + "static/media/ic_cart_white.d1e5f040.png";